module.exports = __webpack_public_path__ + "img/avatar-01.e4157c72.png";